var map = {
	"./24-25/U15_24-25.json": [
		3194,
		194
	],
	"./24-25/U16_24-25.json": [
		3435,
		435
	],
	"./24-25/U18_24-25.json": [
		7773,
		773
	],
	"./24-25/U21_24-25.json": [
		526,
		145
	],
	"./24-25/noi_24-25.json": [
		1961,
		961
	],
	"./U15.json": [
		4534,
		534
	],
	"./U16.json": [
		9223,
		223
	],
	"./U18.json": [
		1341,
		341
	],
	"./U21.json": [
		9113,
		113
	],
	"./noi.json": [
		6461,
		461
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3576;
module.exports = webpackAsyncContext;